import { Button, Drawer } from '@toggle/design-system';
import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { WithFooterWrapper } from '~/components/with-footer-wrapper/WithFooterWrapper';

import { CalendarEventDrawerHeader } from './calendar-event-drawer-header/CalendarEventDrawerHeader';
import * as S from './CalendarEventDrawer.styles';

type CalendarEventDrawerHeaderContent = {
  title: string;
  subtitle: string;
  dateString: string;
  titleLogo?: ReactNode;
  reported?: boolean;
  companyEvent?: boolean;
};

export interface CalendarEventDrawerProps {
  closeDrawer: () => void;
  isOpen: boolean;
  drawerContent: ReactNode;
  headerContent: CalendarEventDrawerHeaderContent;
  onFullScreenClick?: () => void;
}

export const CalendarEventDrawer = ({
  isOpen,
  drawerContent,
  headerContent,
  closeDrawer,
  onFullScreenClick,
}: CalendarEventDrawerProps) => {
  const { t } = useTranslation(['calendar']);
  return (
    <Drawer
      data-testid="calendar-events-drawer"
      isOpen={isOpen}
      handleCloseClick={closeDrawer}
      headerButton={
        onFullScreenClick && (
          <Button
            variant="empty"
            iconName="Expand"
            onClick={onFullScreenClick}
            label={t('calendar:viewMore')}
            size="xsmall"
          />
        )
      }
    >
      <WithFooterWrapper isWrappedComponentOpened={isOpen}>
        <S.ContentWrapper>
          <CalendarEventDrawerHeader
            title={headerContent.title}
            subtitle={headerContent.subtitle}
            logoNode={headerContent.titleLogo}
            dateString={headerContent.dateString}
            reported={headerContent.reported}
            companyEvent={headerContent.companyEvent}
          />
          {drawerContent}
        </S.ContentWrapper>
      </WithFooterWrapper>
    </Drawer>
  );
};
